module.exports = __webpack_public_path__ + "static/media/oscilograf_white.99197031.svg";